import { render, staticRenderFns } from "./AuditHistory.vue?vue&type=template&id=b46ce5e6&scoped=true&"
import script from "./AuditHistory.vue?vue&type=script&lang=js&"
export * from "./AuditHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46ce5e6",
  null
  
)

export default component.exports